/* =================================================================

  ページ内リンクをスムーススクロール

================================================================= */

export const smoothScroll = function () {
  window.addEventListener("DOMContentLoaded", () => {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
    const header = document.querySelector(".js-header");

    anchorLinksArr.forEach((link) => {
      link.addEventListener("click", (e) => {
        // data-no-smooth が付いていれば無効（ネイティブ挙動に任せる）
        if (link.hasAttribute("data-no-smooth")) return;

        const targetId = link.hash; // "#xxx" または ""

        // "#" のみ / "#top" は「ページ最上部へ」をスムーズに実行
        if (!targetId || targetId === "#top") {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: "smooth" });
          return;
        }

        const targetElement = document.querySelector(targetId);
        if (!targetElement) return; // 対象が無ければ何もしない（ネイティブも殺さない）

        e.preventDefault(); // ★対象が確定してから初めて抑止する

        const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
        let totalScrollAmount = targetOffsetTop;

        if (header) {
          totalScrollAmount = targetOffsetTop - header.offsetHeight;
        }

        window.scrollTo({
          top: totalScrollAmount,
          behavior: "smooth",
        });
      });
    });
  });
};
